export default {
    comparison: {
        title: '我們該如何比較？ | 比較圖',
        description: '比較 NobleWills 在價格、準確性、流程等方面與競爭對手相比如何。',
        keywords: '律師事務所,平安紙撰寫者,平安紙樣板',
        heading: '我們該如何',
        heading2: '比較？',
    },
};
